export default "__VITE_ASSET__65d574c2__"